import React, { Component } from 'react';
import styled  from 'styled-components';
import Header from './header.component.js';
import pdf from '../images/pdf.svg';
import document from '../docs/Satzung.pdf';

const Background = styled.div`
    background-color:#f8f9fa !important; 
    border-radius:10px;
    padding: 10px;
    margin: 10px;
`;

const PaddingBottom = styled.div`
    padding-bottom:20px;
`;

const UnorderedList = styled.div`
    display:inline-block !important;
`;

class Statutes extends Component {
	constructor(props) {
  		super(props);
  		this.state = {
  		};
    }

	render() {
    	return (
            <div>
                <div className="container opacity90">
                    <Header text="Satzung" />
                    <div className="row">
                        <div className="col-12 text-center">
                            <Background>
                                <h2>§ 1 Name und Sitz</h2>
                                <PaddingBottom>
                                    Der Verein führt den Namen "Förderverein der Städtischen Kindertagesstätte Bongartzstift".
                                    <br />
                                    Nach erfolgter Eintragung in das Vereinsregister ist dem Vereinsnamen gemäß Satz 1 der Zusatz "e. V." hinzuzufügen.
                                    <br />
                                    Der Sitz des Vereins ist in 41334 Nettetal, Ortsteil Lobberich.
                                </PaddingBottom>
                                <h2>§ 2 Geschäftsjahr</h2>
                                <PaddingBottom>
                                    Geschäftsjahr ist das Kalenderjahr. Das erste Geschäftsjahr ist ein Rumpfgeschäftsjahr.
                                </PaddingBottom>
                                <h2>§ 3 Zweck des Vereins</h2>
                                <PaddingBottom>
                                    Zweck des Vereins ist die Förderung der Jugendhilfe durch die finanzielle Förderung
                                    der Städtischen Kindertagesstätte Bongartzstift, Mühlenstraße 20, 41334 Nettetal.
                                    Träger der Einrichtung ist die Stadt Nettetal. Der Satzungszweck wird verwirklicht
                                    insbesondere durch die Beschaffung von Mitteln. Soweit Mittel vom Träger der
                                    Einrichtung nicht ausreichen, setzt sich der Förderverein für die Ergänzung und
                                    Verbesserung der Räumlichkeiten und Einrichtungen der Kindertagesstätte sowie für
                                    die Förderung von kulturellen, künstlerischen, sprachlichen, musischen und
                                    sportlichen Aktivitäten ein.
                                    <br />
                                    Der Verein setzt sich eine enge Zusammenarbeit mit allen an der erzieherischen Arbeit beteiligten Personen zum Ziel. 
                                    Hierzu gehören die Eltern, der Elternbeirat, die Erzieherinnen, die Leiterin der Kindertagesstätte sowie 
                                    der Träger der Einrichtung.
                                    <br />
                                    Daneben kann der Verein den in § 3 Absatz 1 genannten Zweck auch unmittelbar selbst verwirklichen. 
                                    Der Satzungszweck wird verwirklicht insbesondere durch
                                    <br />
                                    <UnorderedList>
                                        <li>die Durchführung und Mitgestaltung von Kindergartenprojekten;</li>
                                        <li>die Unterstützung der Gremien der Kindertagesstätte;</li>
                                        <li>die Anschaffung von Spielgeräten;</li>
                                        <li>die Unterstützung der pädagogischen Arbeit.</li>
                                    </UnorderedList>
                                    <br />
                                    Der Verein verfolgt ausschließlich und unmittelbar gemeinnützige Zwecke im Sinne
                                    des Abschnitts '' Steuerbegünstigte Zwecke'' der Abgabenordnung.
                                </PaddingBottom>
                                <h2>§ 4 Selbstlose Tätigkeit</h2>
                                <PaddingBottom>
                                    Der Verein ist selbstlos tätig; er verfolgt nicht in erster Linie eigenwirtschaftliche Zwecke. 
                                    Alle Inhaber von Vereinsämtern sind ehrenamtlich tätig.
                                </PaddingBottom>
                                <h2>§ 5 Mittelverwendung</h2>
                                <PaddingBottom>
                                    Mittel des Vereins dürfen nur für die satzungsmäßigen Zwecke verwendet werden.
                                    Die Mitglieder erhalten keine Zuwendungen aus Mitteln des Vereins.
                                    <br />
                                    Die benötigten Mittel erwirkt der Verein durch Mitgliedsbeiträge, Veranstaltungen,
                                    Spenden jeder Art sowie sonstige Zuwendungen und Einnahmen.
                                    <br />
                                    Eine Beitragszahlung, die den festgelegten Mindestmitgliedsbeitrag überschreitet,
                                    wird als Spende behandelt. Eine Haftung der Mitglieder über den festgesetzten
                                    Beitrag hinaus ist ausgeschlossen.
                                </PaddingBottom>
                                <h2>§ 6 Verbot von Begünstigungen</h2>
                                <PaddingBottom>
                                    Es darf keine Person durch Ausgaben, die dem Zweck der Körperschaft fremd sind, oder durch unverhältnismäßig 
                                    hohe Vergütungen begünstigt werden.
                                </PaddingBottom>
                                <h2>§ 7 Erwerb der Mitgliedschaft</h2>
                                <PaddingBottom>
                                    Mitglied des Vereins kann auf schriftlichen Antrag jede natürliche Person, die
                                    mindestens 18 Jahr alt ist, oder jede juristische Person, die den Zweck des Vereins zu
                                    fördern bereit ist, werden.
                                    <br />
                                    Weitere Voraussetzungen ist die schriftliche Verpflichtung zur Zahlung des
                                    Mitgliedsbeitrages.
                                    <br />
                                    Über den Antrag auf Aufnahme entscheidet der Vorstand.
                                    <br />
                                    Gegen die Ablehnung, die keiner Begründung bedarf, steht dem/der Bewerber/in die
                                    Berufung an die Mitgliederversammlung zu, welche dann endgültig entscheidet.
                                </PaddingBottom>
                                <h2>§ 8 Beendigung der Mitgliedschaft</h2>
                                <PaddingBottom>
                                    Die Mitgliedschaft erlischt durch Austritt, Ausschluss, Tod oder Auflösung der juristischen Person.
                                    <br />
                                    Der Austritt erfolgt durch schriftliche Erklärung gegenüber einem vertretungsberechtigten Vorstandsmitglied. 
                                    Die schriftliche Austrittserklärung muss mit einer Frist von einem Monat jeweils zum Ende des Geschäftsjahres 
                                    gegenüber dem Vorstand erklärt werden.
                                    <br />
                                    Ein Mitglied kann durch Vorstandsbeschluss ausgeschlossen werden, wenn
                                    <br />
                                    <UnorderedList>
                                        <li>
                                            das Mitglied für zwei aufeinander folgende Jahre den Mitgliedsbeitrag trotz Mahnung nicht gezahlt hat;
                                        </li>
                                        <li>
                                            sonst ein wichtiger Grund für den Ausschluss der Mitgliedschaft vorliegt.
                                            Ein solcher wichtiger Grund ist insbesondere Verhalten, das dem Verein und seinen Zwecken zuwiderläuft.
                                        </li>
                                    </UnorderedList>
                                    <br />
                                </PaddingBottom>
                                <h2>§ 9 Beiträge</h2>
                                <PaddingBottom>
                                    Von den Mitgliedern werden Beiträge erhoben. Die Höhe und die Zahlungsweise des Mitgliedsbeitrages sowie deren Fälligkeit 
                                    werden von der Mitgliederversammlung festgelegt.
                                </PaddingBottom>
                                <h2>§ 10 Organe des Vereins</h2>
                                <PaddingBottom>
                                    Organe des Vereins sind
                                    <br />
                                    <UnorderedList>
                                        <li>die Mitgliederversammlung</li>
                                        <li>der Vorstand.</li>
                                    </UnorderedList>
                                    <br />
                                </PaddingBottom>
                                <h2>§ 11 Mitgliederversammlung</h2>
                                <PaddingBottom>
                                    Mindestens einmal jährlich findet eine ordentliche Mitgliederversammlung statt. Der
                                    Vorstand kann weitere Mitgliederversammlungen durchführen. Eine außerordentliche
                                    Mitgliederversammlung ist einzuberufen, wenn 10 % der Mitglieder dies schriftlich
                                    unter Angabe von Gründen verlangen oder das Interesse des Vereins dies erfordert.
                                    Die Mitgliederversammlung wird vom Vorstand unter Einhaltung einer Frist von
                                    zwei Wochen in Schriftform (Brief oder E-Mail) einberufen. Dabei ist die vom
                                    Vorstand festgelegte Tagesordnung mitzuteilen.
                                    Die Mitgliederversammlung ist beschlussfähig, wenn mindestens 25 % der
                                    stimmberechtigten Mitglieder anwesend sind. Scheitert die Beschlussfähigkeit an der
                                    Anzahl der erschienenen Mitglieder, so findet eine zweite Mitgliederversammlung
                                    mit der gleichen Tagesordnung statt. Diese ist ohne Rücksicht auf die Anzahl der
                                    erschienenen Mitglieder beschlussfähig. Hierauf ist in der Einladung separat
                                    hinzuweisen. Die Einladung zu beiden Mitgliederversammlungen kann gleichzeitig
                                    erfolgen.
                                    <br />
                                    Die Leitung der Mitgliederversammlung obliegt dem Vorsitzenden, bei dessen
                                    Verhinderung dem stellvertretenden Vorsitzenden.
                                    <br />
                                    Die Mitgliederversammlung ist nicht öffentlich. Der Vorstand kann Gästen die
                                    Teilnahme an der Mitgliederversammlung gestatten. Die Mitgliederversammlung
                                    kann diese Entscheidung mit der Mehrheit der abgegebenen Stimmen aufheben.
                                    <br /> 
                                    Zu Beginn der Mitgliederversammlung ist ein Schriftführer zu wählen.
                                    <br />
                                    Jedes Mitglied hat eine Stimme. Das Stimmrecht kann nur persönlich oder für ein
                                    Mitglied unter Vorlage einer schriftlichen Vollmacht ausgeübt werden.
                                    <br />
                                    Die Mitgliederversammlung fasst ihre Beschlüsse mit der Mehrheit der abgegebenen
                                    Stimmen, soweit die Satzung keine andere Regelung enthält. Die Änderung der
                                    Satzung bedarf einer Mehrheit von zwei Dritteln der abgegebenen Stimmen.
                                    <br />
                                    Stimmenthaltungen und ungültige Stimmen bleiben außer Betracht.
                                    <br />
                                    Über jede Mitgliederversammlung ist ein Protokoll zu fertigen, das vom Leiter der
                                    Sitzung und vom Protokollführer zu unterzeichnen und vom Vorsitzenden
                                    aufzubewahren ist.
                                    Der Mitgliederversammlung obliegen
                                    <br />
                                    <UnorderedList>
                                        <li>die Wahl und die Berufung der Vorstandsmitglieder und der Kassenprüfer;</li>
                                        <li>die Entgegennahme des Jahresberichtes des Vorstandes und des Berichtes der Kassenprüfer;</li>
                                        <li>die Entlastung des Vorstandes und der Kassenprüfer;</li>
                                        <li>die Festsetzung, Zahlungsweise und Fälligkeit der Beiträge;</li>
                                        <li>der Beschluss einer Satzungsänderung;</li>
                                        <li>der Beschluss zur Auflösung des Vereins;</li>
                                        <li>sonstige durch die Satzung ausdrücklich zugewiesene Aufgaben.</li>
                                    </UnorderedList>
                                    <br />
                                    Hat bei Wahlen kein Kandidat die Mehrheit der abgegebenen Stimmen erreicht,
                                    findet zwischen den zwei Kandidaten, die die meisten Stimmen auf sich vereinigen,
                                    eine Stichwahl statt. Gewählt ist, wer die Mehrheit der abgegebenen Stimmen auf
                                    sich vereinigt.
                                    <br />
                                    Anträge über die Abwahl des Vorstands, über die Änderung der Satzung und über die
                                    Auflösung des Vereins, die den Mitgliedern nicht bereits mit der Einladung zur
                                    Mitgliederversammlung zugegangen sind, können erst auf der nächsten
                                    Mitgliederversammlung beschlossen werden.
                                </PaddingBottom>
                                <h2>§ 12 Vorstand</h2>
                                <PaddingBottom>
                                    Der Vorstand im Sinn des § 26 BGB besteht aus dem/der Vorsitzenden, dem/der
                                    stellvertretenden Vorsitzenden und dem/der Kassierer/in.
                                    <br />
                                    Der Vorstand ist zuständig für alle Aufgaben, die nicht der Mitgliederversammlung
                                    obliegen.
                                    <br />
                                    Der Verein wird gerichtlich und außergerichtlich durch zwei der in Satz 1 genannten
                                    Mitglieder des Vorstandes gemeinschaftlich vertreten.
                                    <br />
                                    Der Vorstand führt die laufenden Geschäfte des Vereins. Er hat insbesondere
                                    folgende Aufgaben
                                    <br />
                                    <UnorderedList>
                                        <li>Vorbereitung und Einberufung der Mitgliederversammlung;</li>
                                        <li>Vollzug der Beschlüsse der Mitgliederversammlung</li>
                                        <li>Buchführung</li>
                                        <li>Erstellung eines Jahresberichtes</li>
                                        <li>
                                            Entscheidung über die Verwendung der Mittel (Beiträge und Spenden), wobei
                                            dies nur in Absprache und im Einvernehmen mit der Leitung der Kindertagesstätte erfolgen kann
                                        </li>
                                        <li>Entscheidung über Aufnahmeanträge und Ausschluss von Mitgliedern.</li>
                                    </UnorderedList>
                                    <br />
                                    Der Vorstand wird durch die Mitgliederversammlung für zwei Jahre
                                    gewählt.Wiederwahl ist möglich. Er bleibt so lange im Amt, bis eine Neuwahl erfolgt
                                    ist. Bei Ausscheiden eines Vorstandsmitgliedes ist der Vorstand berechtigt, für die
                                    Zeit bis zur nächsten Mitgliederversammlung ein neues Mitglied zu berufen.
                                    <br />
                                    Die Mitglieder des Vorstandes werden einzeln gewählt. Gewählt ist, wer die
                                    Mehrheit der abgegebenen Stimmen erhält. Die Vereinigung mehrerer
                                    Vorstandsämter in einer Person ist nicht zulässig.
                                    <br />
                                    Wählbar sind nur Vereinsmitglieder bzw. deren gesetzliche Vertreter. Mitarbeiter der
                                    Kindertagesstätte Bongartzstift oder des Einrichtungsträgers sind nicht wählbar.
                                    <br />
                                    Die Mitgliedschaft im Vorstand endet durch schriftliche Erklärung gegenüber dem
                                    Vorstand, durch Beendigung der Vereinsmitgliedschaft oder durch Beschluss der
                                    Mitgliederversammlung, der einer Mehrheit der abgegebenen Stimmen bedarf.
                                    <br />
                                    Der Vorstand führt regelmäßige Sitzungen durch. Über diese ist unter Angabe der
                                    Teilnehmer, der Beschlüsse und der Abstimmungsergebnisse ein Protokoll zu
                                    fertigen, welches von den Teilnehmern zu unterzeichnen und vom Vorsitzenden zu
                                    verwahren ist.
                                    <br />
                                    Die Vorstandssitzung kann jedes Vorstandsmitglied einberufen. Die Einberufung
                                    erfolgt durch schriftliche Einladung mit einer Frist von 7 Tagen und unter Angabe der
                                    Tagesordnung. Im Einvernehmen der Vorstandsmitglieder kann auf die Form und
                                    Frist der Einberufung verzichtet werden.
                                    <br />
                                    Der Vorstand entscheidet durch die Mehrheit der abgegebenen Stimmen. Er ist
                                    beschlussfähig, wenn zwei stimmberechtigte Vorstandsmitglieder anwesend sind.
                                    Stehen die Eintragung im Vereinsregister des zuständigen Amtsgerichtes oder der
                                    Anerkennung der Gemeinnützigkeit durch das zuständige Finanzamt bestimmte
                                    Satzungsinhalte entgegen, ist der Vorstand berechtigt, entsprechende Änderungen
                                    eigenständig durchzuführen.
                                </PaddingBottom>
                                <h2>§ 13 Kassenprüfung</h2>
                                <PaddingBottom>
                                    Die Mitgliederversammlung wählt spätestens in der ersten ordentlichen
                                    Mitgliederversammlung für die Dauer von zwei Jahren zwei Kassenprüfer, die nicht
                                    dem Vorstand angehören dürfen.
                                    <br />
                                    Wiederwahl ist zulässig.
                                    <br />
                                    Die Kassenprüfer haben die Aufgabe die Rechnungsführung zu überwachen, die
                                    Kasse und die Bücher jährlich zu prüfen und in der Mitgliederversammlung
                                    schriftlich zu berichten. Ihnen ist Zugang zu allen Unterlagen zu gewähren. Der
                                    Bericht wird im Protokoll über die Mitgliederversammlung als Anlage beigefügt.
                                </PaddingBottom>
                                <h2>§ 14 Auflösung des Vereins</h2>
                                <PaddingBottom>
                                    Die Auflösung des Vereins kann nur in einer zu diesem Zweck ordnungsgemäß
                                    einberufenen Mitgliederversammlung beschlossen werden.
                                    <br />
                                    Der Beschluss über die Auflösung des Vereins bedarf der Mehrheit von drei Vierteln
                                    der abgegebenen Stimmen.
                                    <br />
                                    Sofern die Mitgliederversammlung keine andere Entscheidung trifft, sind der/die
                                    Vorsitzende und der/die Kassierer/in gemeinsam vertretungsberechtigte Liquidatoren.
                                    Dies gilt entsprechend, wenn der Verein aus einem anderen Grund aufgelöst wird
                                    oder seine Rechtsfähigkeit verliert.
                                    <br />
                                    Bei Auflösung oder Aufhebung des Vereins oder bei Wegfall steuerbegünstigter
                                    Zwecke fällt das Vermögen des Vereins an eine juristische Person des öffentlichen
                                    Rechts oder eine andere steuerbegünstigte Körperschaft zwecks Verwendung für
                                    Förderung der Jugendhilfe in der Städtischen Kindertagesstätte Bongartzstift.
                                </PaddingBottom>
                                <h2>§ 15 Schlussbestimmungen</h2>
                                <PaddingBottom>
                                    Diese Satzung bedarf der Bestätigung durch die erste ordentliche
                                    Mitgliederversammlung. Nach ihrer Bestätigung erhält sie mit dem Datum der
                                    Mitgliederversammlung ihre Gültigkeit für die Arbeit des Vereins.
                                </PaddingBottom>
                                <p className="text-left">
                                    Nettetal, den 17.06.2013
                                </p>
                                <p>
                                    <br />
                                </p>
                                <hr />
                                <p>
                                    Die Satzung ist auch als <strong><a href={document} target="_blank" download>PDF Dokument zum Download</a></strong> verfügbar.
                                    <br />
                                    <a href={document} target="_blank" download><img src={pdf} alt="PDF" className="height50px" /></a>
                                </p>
                            </Background>
                        </div>
                    </div>
                </div>
            </div>
    	);
  	}
}

export default Statutes;


// WEBPACK FOOTER //
// ./src/components/statutes.component.js